import { GenericObject } from '@dxb-web-ui-framework/common/types';
import { AccessControlRepositoryImpl } from '@dxb-web-ui-framework/iam/domain/AccessControl/infrastructure/AccessControlRepositoryImpl';
import { AccessControlServiceImpl } from '@dxb-web-ui-framework/iam/domain/AccessControl/usecases/AccessControlServiceImpl';
import { KeycloakInstance } from 'keycloak-js';
import React, { FC, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { Route, Routes, useNavigate } from 'react-router-dom';
// @ts-ignore
import { AnalyticsProvider } from 'use-analytics';
import { AnalyticsService } from '../../../packages/telemetry/src/domain/Analytics/usecases/GoogleAnalyticsServiceImpl';
import { keycloakInstanceToAppAuthenticationProviderProps } from '../../../packages/iam/src/utils';
import { AppLoader } from '../../../packages/content-composer/src/components/Generic/AppLoader';
import { AppError } from '../../../packages/content-composer/src/components/Generic/AppError';
import { useKeycloak } from '../../../packages/iam/src/context/hooks';
import { AppAuthenticationWrapper } from '../ProviderWrappers/AppAuthenticationWrapper';
import { UserRouter } from './UserRouter';

const accessControlService = new AccessControlServiceImpl(new AccessControlRepositoryImpl());

const RootRouter: FC<GenericObject> = ({ brandConfig }) => {
  const { keycloak, initialized, authenticated } = useKeycloak();
  const authData = keycloakInstanceToAppAuthenticationProviderProps(
    { ...keycloak, authenticated } as KeycloakInstance,
    brandConfig.idleTimeout,
    brandConfig.idleTimerEnabled,
    brandConfig.timerExpirationHandler,
  );
  const navigate = useNavigate();

  const appErrorCallbackOverride = useCallback(() => {
    if (authData?.logout) {
      authData?.logout();
      return;
    }
    navigate('/', { replace: true });
  }, [navigate, authData]);

  const { t } = useTranslation();

  if (!initialized) {
    return <AppLoader />;
  }

  return (
    <AnalyticsProvider instance={AnalyticsService}>
      <AppAuthenticationWrapper
        data={authData}
        accessControlService={accessControlService}
        loaderComponent={<AppLoader />}
        errorComponent={(code?: string) => (
          <AppError
            code={code}
            fullHeight
            message={t('ProvidersApp.AppAuthenticationProvider.AppError.Message')}
            btnLabel={t('ProvidersApp.AppError.btnLabel')}
            onClickBtn={appErrorCallbackOverride}
          />
        )}>
        {authData && (
          <Routes>
            <Route
              path='/*'
              element={<UserRouter brandConfig={brandConfig} appErrorCallbackOverride={appErrorCallbackOverride} />}
            />
          </Routes>
        )}
      </AppAuthenticationWrapper>
    </AnalyticsProvider>
  );
};

export { RootRouter };
